// extracted by mini-css-extract-plugin
module.exports = {"addBtn":"CustomSignsWebcam_addBtn__Pgclb","saveBtn":"CustomSignsWebcam_saveBtn__2_D6c"};